import { CompanyType } from 'src/api';

import { useCurrentUserStaff } from '../user';

export const useIsControlledByPeoOrPeoPayrollProvider = (allowPeoProviderAffiliation = true) => {
  const { employerStaff, peoStaff } = useCurrentUserStaff();

  const isEmployerUnderPeo =
    !!(employerStaff?.employer.peo || employerStaff?.employer.peoPayrollProviderId) &&
    employerStaff.employer.controlledBy !== CompanyType.Employer;

  const isPeoUnderPeoPayrollProvider = !!peoStaff?.peo.peoPayrollProviderId;

  if (allowPeoProviderAffiliation) {
    return isEmployerUnderPeo || isPeoUnderPeoPayrollProvider;
  }

  return isEmployerUnderPeo;
};

export const useIsControlledByPeoUnderPeoPayrollProvider = () => {
  const { employerStaff } = useCurrentUserStaff();

  const isEmployerUnderPeo =
    !!employerStaff?.employer.peo && employerStaff.employer.controlledBy === CompanyType.Peo;

  const isPeoUnderPeoPayrollProvider = !!employerStaff?.employer.peo?.peoPayrollProviderId;

  return isEmployerUnderPeo && isPeoUnderPeoPayrollProvider;
};
